import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  InputNumber,
  message,
  Space,
  Dropdown
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  MenuOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
	ExclamationCircleOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
// import "./CompletedTable.scss";
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const [vendorList, setVendorList] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [modalFlag, setModalFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalType, setModalType] = useState('New');
  const [form] = Form.useForm();

  const initTableHead = {
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 25})
  }

  const initColumns = [
    {
      title: 'Action',
      dataIndex: "viewDetail",
      titleType: "",
      width: 60, 
      render: (text, record) => (
        (
          commonFn.btnAuthorityFlag('Edit') ||
          commonFn.btnAuthorityFlag('Delete')
        ) &&
        (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag('Edit') && {
                key: "Edit",
                icon: <EditOutlined twoToneColor="#1677FF" />,
                label: <div>Edit</div>
              },
              commonFn.btnAuthorityFlag('Delete') && {
                key: "Delete",
                icon: <DeleteOutlined  twoToneColor="#1677FF" />,
                label: <div>Delete</div>
              },
            ],
            onClick: (e) => handleDetailClick(e.key, record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>) || null
      ),
    },
    {
      title: 'HardWare Store',
      dataIndex: "storeName",
      titleType: '',
      isSorter: false,
    },
    {
      title: 'Vendor Name',
      dataIndex: "vendorName",
      titleType: '',
      isSorter: false,
    },
    {
      title: 'Remark',
      dataIndex: "remark",
      titleType: '',
      isSorter: false,
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.hardWareStoreShow, { params });
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  const handleDetailClick = (key, record) => {
		if(key === 'New'){
			setModalType('New')
			setModalFlag(true)
    }
    if(key === 'Edit'){
			setCurrentRecord(record)
			setModalType('Edit')
      const { storeId, vendorId, vendorName, remark, sort } = record
			setVendorList([{value: vendorId, label: vendorName}]);
      form.setFieldsValue({
        storeId,
        vendorId,
        remark,
        sort,
      });
			setModalFlag(true)
    }
    if(key === 'Delete'){
      secondConfirmFn(record.id)
    }
  };

  const newFn = async() => {
    setLoading(true)
    const response = await http.post(api.hardWareStoreAdd, { id: currentRecord?.id, ...form.getFieldValue()});
    if (response.code === "1") {
      message.success(`${modalType} successfully`);
      setModalFlag(false)
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
    setLoading(false)
  }

  const secondConfirmFn = (id) => {
	  Modal.confirm({
      title: 'Delete HardWare Store',
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to delete this data?`,
      okText: 'Sure',
      cancelText: 'Cancel',
      onOk: async() => {
        const response = await http.post(api.hardWareStoreDelete, {id});
        if (response?.code === "1") {
          message.success('Deleted successfully');
      		getTableListFn(pagination.current, pagination.pageSize, tableHead);
        } else {
          commonFn.modalFailedFn(response)
        }
      },
      onCancel() {
        console.log('Cancel');
      },
      style: {
        top: '40%',
      },
    });
	}

	const getVendorListFn = async (content = '') => {
		const response = await http.get(api.vendorSearch, {params: {content}});
		if (response.code === "1") {
			const list = (response.data || []).map((item) => ({
				value: item.vendorId,
				label: item.vendorName,
			}));
			setVendorList(list);
		}
	};

	useEffect(() => {
		if(!modalFlag){
			form.resetFields()
    	setLoading(false)
			setCurrentRecord(null)
    	getVendorListFn()
		}
	}, [modalFlag])

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        {commonFn.btnAuthorityFlag('New') &&
          <Space size="large">
            <Button className="btnGreen" onClick={() => handleDetailClick('New')}>
              <PlusOutlined />
              New
            </Button>
          </Space> || null}
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
      />

      <Modal
        title={`${modalType} HardWare Store`}
        width="50%"
        maskClosable={false}
        open={modalFlag}
        onCancel={() => setModalFlag(false)}
        footer={[
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        ]}
      >
        <Form
          form={form}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          onFinish={newFn}
          validateMessages={{
            required: "${label} is required!",
          }}
        > 
          <Form.Item name="storeId" label="HardWare Store" rules={[{ required: true }]}>
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder="Please select HardWare Store"
              options={[
								{value: 1, label: "HomeDepot"},
								{value: 2, label: "Foothill"},
								{value: 3, label: "Valle Vista"},
								{value: 4, label: "Max's"},
                {value: 5, label: "Ropain Appliance Inc"},
							]}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>

          <Form.Item 
            name="vendorId" 
            label="Vendor Name" 
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              onSearch={getVendorListFn}
              style={{ width: "100%" }}
              placeholder="Please select Vendor Name"
              optionFilterProp="label"
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              options={vendorList}
            />
          </Form.Item>

          <Form.Item name="remark" label="Remark">
            <Input placeholder="Please input Remark" />
          </Form.Item>

					<Form.Item name="sort" label="Sort">
            <InputNumber style={{ width: "100%" }} placeholder="Please input Sort" controls={false} />
          </Form.Item>

        </Form>
      </Modal>
    </div>
  );
});
export default MainTable;